var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageFrame',[_c('div',[_c('h1',[_vm._v("404, Whoops!")]),_c('p',[_vm._v("Seems like the page you are looking for is either missing or doesn't exist.")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to jobs")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }